import styled, { css } from 'styled-components';

const gridRow = css`
  display: flex;
`;

const gridSpan = (columnCount: number) => css`
  width: ${gridColumns(columnCount)};
`;

// Using css`` fails the css linter
const gridColumns = (columnCount: number) => `calc(${columnCount} * var(--grid-column-width))`;

// Using css`` fails the css linter
const gridWidth = 'calc(var(--grid-column-count) * var(--grid-column-width))';

const GridRow = styled.div`
  ${gridRow};
`;

const GridCol = styled.div<{ $width: number, $padLeft?: number, $padRight?: number }>`
  ${({ $width }) => gridSpan($width)};
  ${({ $padLeft }) => $padLeft && css`
    padding-left: ${gridColumns($padLeft)};
  `}
  ${({ $padRight }) => $padRight && css`
    padding-right: ${gridColumns($padRight)};
  `}
`;

export {
  gridRow, gridSpan, gridColumns, gridWidth, GridCol, GridRow,
};
